import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from './bulk-maintenance-error-messages';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    data = [];

    constructor() {}
    
    public modifyHeaders (headers: string[], requiredHeaders: string[]) {
        const newHeaders = [];
        for (const item of headers) {
          let isMatch = false;
          for (const data of requiredHeaders) {
            if (item?.trim().toLowerCase() == data.toLowerCase()) {
              isMatch = true;
              newHeaders.push(data);
              break;
            }
          }
          if (!isMatch) {
            newHeaders.push(item);
          }
        }
        return newHeaders;
      }
  
      public modifyUploadedData (data: any[], headers: string[]) {
         function capitalizeWords(sentence) {
          return sentence.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }
        const updatedData = [];
        for (const item of data) {
          const newData  = {};
          for (const key of Object.keys(item))  {
            const header = headers.find(ele => ele.toLowerCase() == key?.trim().toLowerCase());
              if (item[key] != null && key != 'Portfolio Manager' && key != 'Ucmg Owner' && key != 'L1 MSID' && key != 'L2 MSID' && key != 'L3 MSID') {
                item[key] = capitalizeWords(item[key]);
              }
              newData[header] = item[key];
          }
          updatedData.push(newData);
        }
        
        return updatedData;
      }

    public convertCsvToArray (file: any): Promise<any> {
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(file);
        
        return new Promise((resolve, reject) => {
            reader.onload = (e: any) => {
                try {
                    const binarystr: string = e.target.result;
                    const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
                    const result = this.processWorkbook(wb);
                    
                    if (result.excelRows && result.headers) {
                      resolve(result);
                    } else {
                      reject(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.UNEXPECTED_ERROR);
                    }
                  } catch (error) {
                    reject(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.FILE_PROCESSING_ERROR_PREFIX + error.message);
                }
            };
        });
    }

    private processWorkbook(wb: XLSX.WorkBook): { excelRows: any[], headers: string[] } {
        const sheet_name_list = wb.SheetNames;
        const sheet = wb.Sheets[sheet_name_list[0]];
        const wsname: string = wb.SheetNames[0];
        
        const headers = this.extractHeaders(sheet);
        let excelRows = XLSX.utils.sheet_to_json(wb.Sheets[sheet_name_list[0]], { raw: false });
        
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        this.data = XLSX.utils.sheet_to_json(ws);
        
        excelRows = this.normalizeExcelRows(excelRows, headers);
        
        return { excelRows, headers };
    }

    private extractHeaders(sheet: XLSX.WorkSheet): string[] {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet['!ref']);
        const R = range.s.r;
        
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
            
            if (cell === undefined) {
                break;
            }
            
            const hdr = (cell && cell.t) ? XLSX.utils.format_cell(cell) : '';
            headers.push(hdr);
        }
        
        return headers;
    }

    private normalizeExcelRows(excelRows: any[], headers: string[]): any[] {
        if (excelRows.length === 0) {
            return excelRows;
        }

        excelRows.forEach((row) => {
            headers.forEach((hd) => {
                if (row[hd] === undefined) {
                    row[hd] = '';
                }
            });
        });

        return excelRows;
    }

  public NullCheck(valueInput) {
    const value = valueInput ? valueInput.trim() : null;
    if (
       !value ||
        value === '' ||
        value === null ||

        (typeof value === 'string' && (
          value.toLowerCase() === 'null' ||
          value.toLowerCase() === 'required' ||
          value.toLowerCase() === 'optional' ||
          value.toLowerCase() === 'editable'
        )) ||
      value == ' - ' ||
      value == '-'
    ) {
      return true;
    }
    return false;
  }

  public checkRequiredHeaders(headers: string[], requiredHeaders: string[]) {
    const missingHeader = requiredHeaders.filter(item => !headers.includes(item));
    return missingHeader;
  }

  public getPrimaryUploadRequiredHeaders(): string[] {
    const primaryUploadRequiredHeaders = [
      'Update Type',
      'GLOBAL APP ID', 'LOB ID',
      'Sub LOB ID', 'Capability L0 Id', 'Group Model',
      'Capability L1 Id', 'Capability L2 Id', 'Capability L3 Id',
      'Primary Status'
    ];
    return primaryUploadRequiredHeaders;
  }
  public appDemoRequiredHeaders(): string[] {
    const deomgraphicRequiredHeaders = [
      'Update_Type(U)',
      'GLOBAL APP ID', 'LOB ID',
      'Sub LOB ID', 'Category_ID', 'Application_Type_Id', 
      'Application_Hosting_ID'
    ];
    return deomgraphicRequiredHeaders;
  }
  public getModelEditRequiredHeaders(): string[] {
      const modelEditRequiredHeaders = [
        'Update Type',
        'Group_Model', 
        'Capability_L0_Id', 'Capability_L0', 'Capability_L0_Desc',
        'Capability_L1_Id', 'Capability_L1', 'Capability_L1_Desc',
        'Capability_L2_Id', 'Capability_L2', 'Capability_L2_Desc',
        'Capability_L3_Id', 'Capability_L3', 'Capability_L3_Desc'
    ]
    return modelEditRequiredHeaders;
  } 
  public modeleditAllFields(): string[] {
    const allModelEditHeaders =  [
      'Update Type',
      'Group_Model', 
      'Capability_L0_Id', 'Capability_L0', 'Capability_L0_Desc',
      'Capability_L1_Id', 'Capability_L1', 'Capability_L1_Desc',
      'Capability_L2_Id', 'Capability_L2', 'Capability_L2_Desc',
      'Capability_L3_Id', 'Capability_L3', 'Capability_L3_Desc',
      'Status','Message'
    ]
    return allModelEditHeaders;
  }

   public modeleditRequiredFields(): string[] {
    const allModelEditHeaders =  [
      'Update Type',
      'Group_Model', 
      'Capability_L0_Id', 'Capability_L0', 'Capability_L0_Desc',
      'Capability_L1_Id', 'Capability_L1', 'Capability_L1_Desc',
      'Capability_L2_Id', 'Capability_L2', 'Capability_L2_Desc',
      'Capability_L3_Id', 'Capability_L3', 'Capability_L3_Desc'
     
    ]
    return allModelEditHeaders;
  }

  public appPaduAllFields(): string[] {
       const  paduRequiredHeaders = [
        'Update_Type(U)',
        'GLOBAL APP ID',
        'LOB ID',
        'Sub LOB ID',
        'Application PADU',
        'Application PADU T1',
        'Application PADU T2',
        'Application PADU T3',
        'Application PADU T4',
        'Application PADU T5',
        'Application PADU T6',
        'Decom Forecast QTR',
        'Decom Forecast Year',
        'Notes / Comments', 
        'RoadMap', 
        'Replacement App', 
        'Initiative / Program', 
        'Business Owned',
        'Tech/Business Alignment Needed',
        'Non Integrated Tech',
        'Migration Forecast Year',
        'Migration Forecast QTR',
        'Application Strategy',
    ];
    return paduRequiredHeaders;
  }

  public appdemoAllFields(): string[] {
     const deomgraphicRequiredHeaders = [
    'Update_Type(U)',
    'GLOBAL APP ID', 'LOB ID',
    'Sub LOB ID', 'Category_ID', 'Application_Type_Id',
    'Application_Hosting_ID'
  ];
    return deomgraphicRequiredHeaders;
  }

  public capabilityMappingAllFields(): string[] {
    const capabilityMappingAllFields = [
      'Update Type',
      'GLOBAL APP ID',
      'LOB ID',
      'Sub LOB ID',
      'Group Model',
      'Organization ID',
      'Capability L0 Id',
      'Capability L1 Id',
      'Capability L2 Id',
      'Capability L3 Id',
      'Capability PADU',
      'Capability PADU T1',
      'Capability PADU T2',
      'Capability PADU T3',
      'Capability PADU T4',
      'Capability PADU T5',
      'Capability PADU T6',
      'Application PADU',
      'Application PADU T1',
      'Application PADU T2',
      'Application PADU T3',
      'Application PADU T4',
      'Application PADU T5',
      'Application PADU T6'
    ]
    return capabilityMappingAllFields;
  };
 public findDuplicatesAndUniqueRecords(dataset: any[], uniqueKeys: string[]) {
  const uniques = [];
  const duplicates = [];
  const seen = new Map<string, any>();
  for (const data of dataset) {
    const key = uniqueKeys.map(k => data[k]).join('|');
    if (seen.has(key)) {
      data['Status'] = 'FAIL';
      data['Message'] = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.DUPLICATE_RECORD;
      duplicates.push(data);
    } else {
      data['Status'] = 'Success';
      data['Message'] = '';
      uniques.push(data);
      seen.set(key, data);
    }
  }
  return { uniques, duplicates };
}

  public allowedValueCheck(value: string, allowedValues: string[]): boolean {
  if (!Array.isArray(allowedValues)) {
    return false;
  }
  if (typeof value !== 'string') {
    return false;
  }
  return allowedValues.map(v => v.toLowerCase()).includes(value.trim().toLowerCase());
}

   public appendError(ele: any, message: string) {
      ele['Status'] = 'Fail';
      ele['Message'] = ele['Message'] ? ele['Message'] + ', ' + message : message;
    }
  

   public appendMultipleMessage(obj: any, newMessage: string): string {
    return obj.message ? `${obj.message}, ${newMessage}` : newMessage;
  }

  public noMappingCheck(obj: any, fieldsToCheck: any[]): any {
    for (const key of fieldsToCheck) {
      if (obj[key] && obj[key].trim().toLowerCase() == 'no mapping') {
        obj['Status'] = false;
        let errmessage = `No Mapping is not a valid value for ${key}`;
        obj['Message'] = this.appendMultipleMessage(obj, errmessage)
      }
    }
    return obj;
  }

  public validateFieldsAndUpdateType(requiredFields: any[], excelRow: any[], index: number, obj: any, allowedUpdateTypes: string[]) {
    for (const field of requiredFields) {
      const value = excelRow[field.key];
      const check = (field?.validCheck)
        ? (!this.NullCheck(value) && !this.allowedValueCheck(String(value), allowedUpdateTypes))
        : this.NullCheck(value);

      if (check) {
        obj = {
          status: false,
          index,
          message: this.appendMultipleMessage(obj, field.message)
        };
      }
    }
    return obj;
  }

   public initializeValidationObject() {
    return { status: null, index: null, message: '' };
  }

  public createErrorObject(index: number, message: string) {
    return { status: false, index, message };
  }

  public trimObjValues(obj: any) {
    Object.keys(obj).forEach(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
  }

  public validateFiscalYearField(ele: any, field: string, label: string) {
    // Let required-field validation handle empty/null values
    if (this.NullCheck(ele[field])) return;
  
    const raw = String(ele[field]).trim();
    const value = Number(raw);
  
    if (!Number.isFinite(value)) {
      this.appendError(ele, BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.SHOULD_BE_NUMBER(label));
      return;
    }
  
    if (!Number.isInteger(value)) {
      this.appendError(ele, BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.SHOULD_BE_INTEGER(label));
      return;
    }
  
    const year = value; // already integer
    // Pick a range that matches your business rules
    if (year < 1900 || year > 2100) {
      this.appendError(ele, `${label} should be a valid year (e.g., 2024)`);
      return;
    }
  
    ele[field] = year; // normalize
  }

    public validateRequiredIntegerField(ele: any, field: string, label: string) {
    const nullCheck = this.NullCheck(ele[field]);
    if (nullCheck) {
      ele['Status'] = 'Fail';
      const msg = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.REQUIRED_FIELD(label);
      ele['Message'] = ele['Message'] ? ele['Message'] + `, ${msg}` : msg;
      
    }
    try {
      if (isNaN(ele[field])) {
        ele['Status'] = 'Fail';
        const msg = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.SHOULD_BE_NUMBER(label);
        ele['Message'] = ele['Message'] ? ele['Message'] + `, ${msg}` : msg;
       
      }
      ele[field] = Number(ele[field]);
      if (!Number.isInteger(ele[field])) {
        ele['Status'] = 'Fail';
        const msg = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.SHOULD_BE_INTEGER(label);
        ele['Message'] = ele['Message'] ? ele['Message'] + `, ${msg}` : msg;
      }
    } catch (e) {
      ele['Status'] = 'Fail';
      const msg = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.CONVERSION_ERROR(label);
      ele['Message'] = ele['Message'] ? ele['Message'] + `, ${msg}` : msg;
    }
  }
 /**
   * @description: Validate file format
   */
  public validateFileFormat(fileToUpload: File): boolean {
    const fileType = fileToUpload.type;
    const fileExtension = fileToUpload.name.split('.').pop();
    
    const supportedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const supportedExtensions = ['xls', 'xlsx', 'xlsm', 'xlsb'];
    
    if (!fileType || !supportedTypes.includes(fileType) || !supportedExtensions.includes(fileExtension)) {
      return false;
    }
    return true;
  }


}